import { defineStore } from 'pinia'
import { PageLoadingStoreEnum } from '../enums/pageLoadingStoreEnum.js'
import { ref } from 'vue'

/**
 * 用於管理頁面加載狀態
 */
export const usePageLoadingStore = defineStore(PageLoadingStoreEnum.Key, () => {
    /**
     * 當前頁面是否正在加載
     */
    const isLoading = ref<boolean>(false)


    /**
     * 顯示加載狀態
     * @return {void}
     */
    const showLoading = (): void => {
        isLoading.value = true
    }

    /**
     * 隱藏加載狀態
     * @return {void}
     */
    const hideLoading = (): void => {
        isLoading.value = false
    }


    return {
        isLoading,
        showLoading,
        hideLoading,
    }
})
